module.exports = __webpack_public_path__ + "img/Weapon_297.4f72042f.png";